module.exports = __webpack_public_path__ + "media/recipes/27-8e057674.png";